const QUIET_MS = 200
const MAX_WAIT_MS = 2500
const USER_SCROLL_EVENTS = ['wheel', 'touchstart', 'keydown'] as const

const getSectionScrollTop = (section: HTMLElement): number => {
    const { top, height } = section.getBoundingClientRect()
    const availableHeight = window.innerHeight

    return top + window.scrollY - Math.max(0, (availableHeight - height) / 2)
}

export const scrollToSection = (id: string): void => {
    const section = document.getElementById(id)
    if (!section) return

    window.scrollTo({ top: getSectionScrollTop(section), behavior: 'smooth' })
}

export const scrollToHashWhenStable = (hash: string): void => {
    const id = decodeURIComponent(hash.slice(1))
    if (!id) return

    let quietTimer: ReturnType<typeof setTimeout> | undefined

    const observer = new ResizeObserver(() => {
        clearTimeout(quietTimer)
        quietTimer = setTimeout(scrollToTarget, QUIET_MS)
    })
    const maxTimer = setTimeout(scrollToTarget, MAX_WAIT_MS)

    function cleanUp(): void {
        observer.disconnect()
        clearTimeout(quietTimer)
        clearTimeout(maxTimer)
        USER_SCROLL_EVENTS.forEach((event) => window.removeEventListener(event, cleanUp))
    }

    function scrollToTarget(): void {
        cleanUp()
        scrollToSection(id)
    }

    observer.observe(document.body)
    USER_SCROLL_EVENTS.forEach((event) =>
        window.addEventListener(event, cleanUp, { passive: true }),
    )
}
